import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  ThemeProvider,
  createTheme,
  styled,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import { useHistory } from "react-router-dom";
import { onSignOut } from "../../auth";
import AppContext from "../../pages/app/context";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import CustomizedSnackbars from "../../components/alert/Alert";

let text = "";
let tipo = "";

export default function Perfil({ match }) {
  const [alerta, setAlerta] = useState(false);
  const [confirmando, setConfirmando] = useState(false);
  const [dados, setDados] = useState("");
  const [funcoes, setFuncoes] = useState([]);
  const usuario = useContext(AuthContext);
  const history = useHistory();
  const { notification } = useContext(AppContext);
  const [formulario, setFormulario] = useState({
    nome: "",
    CPF: "",
    email: "",
    funcaoId: 0,
    escolaNome: "",
  });

  useEffect(() => {
    carregarDados();
    carregarComboFuncoes();
  }, []);

  const carregarDados = () => {
    api
      .get("profissionais/carregar", { id: usuario.usuario.profissionalId })
      .then((res) => {
        setDados(res);

        const dadosCarregados = {
          nome: res.usuarioNome,
          CPF: res.usuarioCPF,
          email: res.usuarioEmail,
          funcaoId: res.funcaoId,
          escolaNome: res.escolaNome,
        };

        setFormulario(dadosCarregados);
        // const profissional = res.data;
        // if(!profissional || !profissional.usuario) return this.sair();
        // const chaveOffline = `@PERTOAPP:perfil${profissionalId}`;
        // AsyncStorage.setItem(chaveOffline, JSON.stringify(profissional));
        // this.preencherFormulario(profissional, true);
      })
      .catch(() => {
        text =
          "Não foi possível carregar o perfil. Verifique sua conexão e tente novamente.";
        tipo = "error";
        alertMsg();
        return;
        // this.carregarOffline(profissionalId);
      });
  };

  const carregarComboFuncoes = () => {
    api
      .get("funcoes/listar", { ativas: true })
      .then((funcoes) => {
        setFuncoes(funcoes);
      })
      .catch(() => {});
  };

  if (!dados) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }

  const salvar = (e) => {
    e.preventDefault();

    const profissionalSalvar = formulario;
    profissionalSalvar.id = usuario.usuario.profissionalId;

    if (!profissionalSalvar.nome) {
      return notification("warning", "Informe o nome");
    }

    if (!profissionalSalvar.CPF) {
      return notification("warning", "Informe o cpf");
    }

    if (!profissionalSalvar.email) {
      return notification("warning", "Informe seu email");
    }

    if (!profissionalSalvar.funcaoId === 0) {
      return notification("warning", "Selecione sua função");
    }
    api
      .post("profissionais/editarViaApp", profissionalSalvar)
      .then((res) => {
        return notification("success", "Dados salvos com sucesso!");
      })
      .catch((err) => {
        if (!err.data) {
          text =
            "Não foi possível enviar os dados para o servidor. Verifique sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
          return;
        }

        const codes = err.data;

        if (codes.includes(4)) {
          text =
            "CPF já cadastrado na base da Perto. Se necessário, utilize a opção de recuperação de senha.";
          tipo = "error";
          alertMsg();
          return;
        }

        if (codes.includes(2)) {
          text = "Verifique o CPF informado e tente novamente.";
          tipo = "error";
          alertMsg();
          return;
        }

        text = "Verifique os dados e tente novamente.";
        tipo = "error";
        alertMsg();
        return;
      });
  };

  const sair = () => {
    onSignOut();
    // history.push('/');
    history.go(0);
  };

  const preencher = (campo, valor) => {
    const formularioAtualizado = { ...formulario };

    formularioAtualizado[campo] = valor;

    setFormulario(formularioAtualizado);
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <Box
      style={{
        background: "#3d79bd",
        height: window.innerHeight,
        alignItems: "center",
        display: "flex",
      }}
    >
      <Helmet>
        <title>Meu perfil</title>
        <meta name="description" content="Perfil" />
      </Helmet>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
          <h4
            style={{
              textDecoration: "none",
              color: "white",
              fontSize: "1.5rem",
              fontFamily: "Gilroy-ExtraBold",
            }}
          >
            Dados pessoais
          </h4>
        </Grid>

        <form onSubmit={salvar}>
          <Grid
            container
            item
            xs={12}
            style={{
              // textAlign: "center",
              padding: !isMobile ? "0px 20% 0px 20%" : 10,
            }}
          >
            <Grid item xs={12}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                id="nome"
                label="Nome completo"
                variant="filled"
                type="text"
                fullWidth
                onChange={(event) => preencher("nome", event.target.value)}
                value={formulario.nome}
              />
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                fullWidth
                id="CPF"
                label="CPF"
                variant="filled"
                type="number"
                pattern="[0-9]+"
                onChange={(event) => preencher("CPF", event.target.value)}
                value={formulario.CPF}
              />
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                fullWidth
                id="email"
                label="Email"
                variant="filled"
                type="text"
                onChange={(event) => preencher("email", event.target.value)}
                value={formulario.email}
              />
            </Grid>

            <Grid item xs={12}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                fullWidth
                id="funcao"
                select
                label="Função"
                value={formulario.funcaoId}
              >
                {funcoes.map((option) => (
                  <MenuItem
                    onClick={(event) => preencher("funcaoId", option.id)}
                    key={option.value}
                    value={option.id}
                  >
                    {option.nome}
                  </MenuItem>
                ))}
              </FormTextField>
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                id="escola"
                label="Escola"
                variant="filled"
                type="text"
                fullWidth
                onChange={(event) => preencher("nome", event.target.value)}
                value={dados.escolaNome}
              />
            </Grid>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <ThemeProvider theme={theme}>
                <Button
                  fullWidth
                  style={{
                    color: "white",
                    marginTop: "10px",
                    marginBottom: "10px",
                    fontWeight: "bold",
                    width: "50%",
                    fontFamily: "Gilroy-ExtraBold",
                  }}
                  type="submit"
                  variant="contained"
                >
                  Salvar
                </Button>
              </ThemeProvider>
            </Grid>

            <Grid item xs={12} style={{ color: "white", cursor: "pointer" }}>
              <h3
                onClick={() =>
                  history.push({
                    pathname: "escola",
                    state: { escolaId: dados.escolaId, viaPerfil: true },
                  })
                }
              >
                Gerenciar ciclos
              </h3>
            </Grid>
            <Grid item xs={12} style={{ color: "white", cursor: "pointer" }}>
              <h3 onClick={() => setConfirmando(true)}>Sair</h3>
            </Grid>
          </Grid>
        </form>
      </Grid>
      {alerta && (
        <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
      )}

      <Dialog
        open={confirmando}
        onClose={() => setConfirmando(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Deseja realmente sair?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Será necessário efetuar um novo login para voltar a utilizar a
            plataforma.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              sair();
              setConfirmando(false);
            }}
          >
            confirmar
          </Button>
          <Button onClick={() => setConfirmando(false)}>cancelar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const FormTextField = styled((props) => (
  <TextField
    InputProps={{
      style: {
        fontWeight: "bolder",
      },
      disableUnderline: true,
    }}
    InputLabelProps={{
      style: { color: "black", fontFamily: "Gilroy-ExtraBold" },
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    borderRadius: 10,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: "#F5B01B",
    },
  },
});
